/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_Original_LanguageInputs */



/**
* | output |
* | --- |
* | "Include Original Language" |
*
* @param {Transcript_Export_Include_Original_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_original_language = /** @type {((inputs?: Transcript_Export_Include_Original_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_Original_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure la langue d'origine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originalsprache einbeziehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi la lingua originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить оригинальный язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir idioma original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包含原始语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元の言語を含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल भाषा शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir idioma original")
	return /** @type {LocalizedString} */ ("Include Original Language")
});